<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <g clip-path="url(#clip0_18847_75711)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 7C0 3.13438 3.13438 0 7 0C10.8656 0 14 3.13438 14 7C14 10.8656 10.8656 14 7 14C3.13438 14 0 10.8656 0 7ZM1.1875 7C1.1875 10.2094 3.79063 12.8125 7 12.8125C10.2094 12.8125 12.8125 10.2094 12.8125 7C12.8125 3.79063 10.2094 1.1875 7 1.1875C3.79063 1.1875 1.1875 3.79063 1.1875 7ZM4 6.625C4 6.55625 4.05625 6.5 4.125 6.5H9.875C9.94375 6.5 10 6.55625 10 6.625V7.375C10 7.44375 9.94375 7.5 9.875 7.5H4.125C4.05625 7.5 4 7.44375 4 7.375V6.625Z" fill="#BECCE5"/>
  </g>
  <defs>
    <clipPath id="clip0_18847_75711">
      <rect width="14" height="14" fill="white"/>
    </clipPath>
  </defs>
</svg>